import { useContext } from 'react';
import { ButtonsGroup } from '@hungryroot/pho';
import { ContainerFrequencyOptions } from '@hungryroot/rest';
import { QuizContext } from '../../quiz-context';
import { type QuizFrequencyKeys } from '../../quiz-hooks';

interface Props<T extends QuizFrequencyKeys> {
  testid?: string;
  question: T;
  setTrackedFrequency?: (frequency: ContainerFrequencyOptions) => void;
}

export function ControlFrequency<T extends QuizFrequencyKeys>(props: Props<T>) {
  const { question, testid, setTrackedFrequency } = props;

  const { quiz, onQuestionAnswer } = useContext(QuizContext);
  const { [question]: frequency } = quiz;
  return (
    <ButtonsGroup
      testid={testid}
      selected={frequency}
      handleClick={(value) => {
        setTrackedFrequency?.(value);
        onQuestionAnswer(quiz, question, value);
      }}
      options={[
        {
          label: 'All',
          value: ContainerFrequencyOptions.All,
        },
        {
          label: 'Some',
          value: ContainerFrequencyOptions.Some,
        },
        {
          label: 'None',
          value: ContainerFrequencyOptions.None,
        },
      ]}
    />
  );
}
